import React, { memo } from 'react';

import InputSearch from '@cobliteam/ui/form/InputSearch';
import type { Column, Table } from '@tanstack/react-table';

import DataTableColumns from '../components/DataTableColumns';
import ExportComponent from '../components/Export';

interface SearchAndToolsProps<TData> {
  globalFilter: string;
  onChangeSearch?: (value: string) => void;
  table: Table<TData>;
  columns: Column<TData>[];
  visibleColumns: Column<TData>[];
  customToolbar: React.ReactNode;
  exportDef: any;
  Export: any;
  data: TData[];
  placeholder?: string;
  search?: string | boolean;
  showColumnFilter?: boolean;
}

const DataTableSearchAndTools = <TData,>({
  data,
  globalFilter,
  onChangeSearch,
  table,
  columns,
  visibleColumns,
  customToolbar,
  exportDef,
  Export,
  placeholder = 'Pesquisar...',
  search = true,
  showColumnFilter = true,
}: SearchAndToolsProps<TData>) => {
  const searchRef = React.useRef<HTMLInputElement>(null);
  const searchValue = typeof search === 'string' ? search : globalFilter;
  return (
    <div className='grid grid-cols-12 space-y-2 pb-3 sm:space-y-0'>
      <div className='col-span-12 flex flex-wrap items-center gap-2.5 sm:col-span-6 md:col-span-8 lg:col-span-8 lg:flex-nowrap lg:gap-5 xl:col-span-8'>
        {search !== false && (
          <InputSearch
            id='data-table-search'
            placeholder={placeholder}
            initialValue={searchValue}
            debounceInMillis={500}
            className='w-full min-w-72 max-w-96'
            onChange={(value: string) => {
              if (value === globalFilter) return;

              onChangeSearch?.(value);
              searchRef?.current?.focus();
              table.setGlobalFilter(value);
            }}
          />
        )}
        {customToolbar}
      </div>
      <div className='col-span-12 flex items-center justify-start gap-2 sm:col-span-6 sm:justify-end md:col-span-4 lg:col-span-4 xl:col-span-4'>
        {showColumnFilter && <DataTableColumns columns={columns} visibleColumns={visibleColumns} />}
        <div>
          {exportDef && Export && data ? Export(table, data, exportDef) : null}
          {!exportDef && Export && data ? Export(table, data, exportDef) : null}
          {exportDef && !Export && data ? <ExportComponent data={data} table={table} exportDef={exportDef} /> : null}
        </div>
      </div>
    </div>
  );
};

export default memo(DataTableSearchAndTools);
